import { useQuery } from "@tanstack/react-query";
import { useAxios } from "../useAxios";
import type { PlayerStatisticsDto, QuizStatisticsFilter } from "../../types/quiz-statistics";

export const useGetPlayerStatistics = (
  examId: string | null,
  userId: string | null,
  filter: QuizStatisticsFilter,
  enabled = true
) => {
  const axios = useAxios();

  return useQuery<PlayerStatisticsDto>({
    queryKey: ["playerStatistics", examId, userId, filter],
    queryFn: async () => {
      const params = new URLSearchParams();
      if (filter.startDate) params.append("startDate", filter.startDate);
      if (filter.endDate) params.append("endDate", filter.endDate);
      const query = params.toString() ? `?${params.toString()}` : "";
      const { data } = await axios.get<PlayerStatisticsDto>(
        `/api/challenges/PlayerStatistics/${examId}/${userId}${query}`
      );
      return data;
    },
    enabled: !!examId && !!userId && enabled,
    refetchInterval: 15_000,
  });
};
